<template>
	<div class="from_box flex">
		<div class="item">
			<span class="txt">凭证日期：</span>
			<el-date-picker
			 v-model="fromData.voucherDate"
			  type="date"
			  placeholder="选择日期">
			</el-date-picker>
		</div>
		<div class="item">
			<span class="txt">过账日期：</span>
			<el-date-picker
			v-model="fromData.postingDate"
			  type="date"
			  placeholder="选择日期">
			</el-date-picker>
		</div>
    <div class="item">
    	<span class="txt">工厂：</span>
    	<el-autocomplete
    	  v-model="fromData.factoryStr"
    	  :fetch-suggestions="factoryQuerySearchAsync"
    	  :placeholder="$store.state.remark.factory"
    	  :trigger-on-focus="false"
    	  @select="handleSelectFactory"
    	  @keyup.enter.native="enterHandleSelectFactory"
    	  @blur="enterHandleSelectFactory"
    	  ref="factoryAuto"
        clearable
        @clear="factoryClear"
    	></el-autocomplete>
    </div>
    <div class="item">
    	<span class="txt">库存地点：</span>
    	<el-select v-model="fromData.inventoryId" @change="changeFstock" :disabled="isFactoryInventory" placeholder="请选择库存地点">
    	    <el-option
    	      v-for="item in fstockList"
        :label="item.value"
    		  :key="item.inventoryId"
    	      :value="item.inventoryId">
        <span style="float: left">{{ item.inventoryCode}}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.inventoryDesc}}</span>
    	    </el-option>
    	  </el-select>
    </div>
		<div class="item">
			<span class="txt">客户：</span>
			<el-autocomplete
			  v-model="fromData.customerStr"
			  :fetch-suggestions="querySearchAsync"
			  :placeholder="$store.state.remark.customer"
			  :trigger-on-focus="false"
			  @select="handleSelect"
			  @keyup.enter.native="enterHandleSelect"
			  @blur="enterHandleSelect"
			  ref="factoryAuto"
			></el-autocomplete>
		</div>
		<div class="item">
			<span class="txt">备注：</span>
			<el-input
			v-model="fromData.voucherHeaderTxt"
			:placeholder="$store.state.remark.remark"
			></el-input>
		</div>
	</div>
</template>

<script>
import {fstockApi} from 'api/base.js';
export default{
	components:{

	},
	props:{
		fromData:Object,
		noFromData:Object,
		customerList:Array,
		factoryList:Array
	},
	data(){
		return {
			//已选的供应商
			customerListRes:{},
			//已选的工厂
			factoryListRes:{},
			fstockList:[],//库存地信息
			isFactoryInventory:true,//库存地是否禁用
      downloadUrl:"http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/tpl",
      uploadUrl:"http://192.168.2.249:8080/purchasemng/purchaseinstock/excel/importmaterial",
			//获取库位信息
			fromFstock:{
				"page": 1,
				"pageSize": 10000,
				"searchCriteria": {
				}
			},
		}
	},
	created(){
    //凭证和过账默认今天
    let nowData = new Date();
    this.$set(this.fromData,'voucherDate',nowData);
    this.$set(this.fromData,'postingDate',nowData);
	},
	methods:{
		//获取库位信息
		async getFstock(fid){
			this.fromFstock.searchCriteria.factoryId = fid;
			let fstockList = await this.$post(fstockApi.list,this.fromFstock);
		  if(!fstockList.status) return false;
		  if(fstockList.data){
		    this.isFactoryInventory = false;
		    this.fstockList = fstockList.data.list;
		    this.fstockList.forEach((item)=>{
		      item.value = item.inventoryCode +'-' + item.inventoryDesc
		    });
		  }else{
		    this.fstockList = [];
		  }
		},
		//库位信息改变
		changeFstock(val){
		  let res = this.fstockList.find(v=>v.inventoryId==val);
      if(res){
        this.fromData.inventoryCode = res.inventoryCode;
        this.fromData.inventoryDesc = res.inventoryDesc;
        this.fromData.inventoryId = res.inventoryId;
      }else{
		    this.fromData.inventoryCode = "";
		    this.fromData.inventoryDesc = "";
		    this.fromData.inventoryId = "";
		  }
		},
		//工厂检索
		factoryQuerySearchAsync(queryString, cb) {
			var restaurants = this.factoryList;
			var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
			this.factoryListRes = results;
			/* this.timeout = setTimeout(() => {
			}, 1000 * Math.random()); */
			cb(results);
		},
		querySearchAsync(queryString, cb) {
			var restaurants = this.customerList;
			var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
			this.customerListRes = results;
			cb(results);
		},
		createStateFilter(queryString) {
			return (state) => {
				if(state.value){
					return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
				}
			};
		},
		//输入客户
		enterHandleSelect(){
      if(!this.fromData.customerStr) return;
			if(this.customerListRes.length){
				let item = this.customerListRes[0];
				this.handleSelect(item);
			}else{
				let scode = this.fromData.customerCode;
				let res = this.customerList.find(v=>v.customerCode === scode);
				if(res){
					this.handleSelect(res);
				}else{
					this.$message.error('没有此客户');
					this.fromData.customerDesc = '';
					this.fromData.customerCode = '';
					this.fromData.customerId = 0;
          this.fromData.customerStr = "";
				}
			}
		},
		//工厂
		enterHandleSelectFactory(){
		  if(!this.fromData.factoryStr) return false;
			if(this.factoryListRes.length){
				let item = this.factoryListRes[0];
		    this.handleSelectFactory(item);
			}else{
				let fcode = this.fromData.factoryCode;
				let res = this.factoryList.find(v=>v.factoryCode === fcode);
				if(res){
					this.handleSelectFactory(res);
				}else{
					this.$message.error('没有此工厂');
		      this.fromData.factoryId = '';
					this.fromData.factoryCode = '';
		      this.fromData.factoryDesc = '';
		      this.fstockList = [];
					this.isFactoryInventory = true;
				}
			}
		},
		//选择工厂后
		handleSelectFactory(item){ 
			if(item.factoryId != this.fromData.factoryId){//重新获取库位数据
				this.getFstock(item.factoryId);
			}
			this.fromData.factoryCode = item.factoryCode;
			this.fromData.factoryDesc = item.factoryDesc;
			this.fromData.factoryId = item.factoryId;
		  this.fromData.factoryStr = item.factoryCode +"-"+ item.factoryDesc;
			this.isFactoryInventory = false;
		},
		//清空工厂
		factoryClear(){
		  this.$set(this.fromData,'factoryId','');
		  this.$set(this.fromData,'factoryCode','');
		  this.$set(this.fromData,'factoryDesc','');

		  this.$set(this.fromData,'inventoryId','');
		  this.$set(this.fromData,'inventoryCode','');
		  this.$set(this.fromData,'inventoryDesc','');

		  this.fstockList = [];
		  this.isFactoryInventory = true;
		},
		//客户选择后
		handleSelect(item) {
			this.fromData.customerDesc = item.customerName;
			this.fromData.customerId = item.customerId;
			this.fromData.customerCode = item.customerCode;
      		this.fromData.customerStr = item.customerCode +'-'+ item.customerName
		},
	}
}
</script>

<style>
</style>
